module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10234.8334edaa.jpg";